export default __webpack_public_path__ + "static/media/6_map.3f43bf72.png";